export const environment = {
    production: false,
    appName: 'PR',
    origin: 'PR',
    appIconColor: "#FF3333",
    mydocmaConfig: {
        apiUrl: 'https://api-test.edr-software.com/mydocma',
        clientUrl: 'https://mydocma-test.edr-software.com',
        appId: '856d7718-2549-4086-88df-93d03135ca06'
    },
    authConfig: {
        clientId: 'mydocma.PR',
        scope: 'offline_access iam',
        oidc: false,
        issuer: 'https://api-test.edr-software.com/mydocma',
        redirectUri: 'http://localhost:4200/auth/callback',
        requireHttps: false,
        responseType: 'code',
        ignoredUrls: [
            '//assets.edr-software.com',
            'https://assets.edr-software.com',
        ],
        logoutUrl: 'https://mydocma-test.edr-software.com/account/logout',
        postLogoutRedirectUri: ''
    },
    prConfig: {
        apiUrl: 'https://node-test.edr-software.com/pr/',
        origin: 'PR'
    },
    webSocketConfig: {
        serverUrl: 'wss://node-test.edr-software.com:443/websocket/',
        reconnectInterval: 20000,
        reconnectAttempts: -1,
        heartbeatInterval: 20000,
    },
    taskConfig: {
        apiUrl: 'https://node-test.edr-software.com/tasks-api'
    },
    appContainerConfig: {
        showBackdropOnCustomerChange: true
    }
};
